// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1EcOq","buttons":"PendingPaymentAlert_buttons__1tnPY"};